module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "extra_buttons"
  }, [_c('ExtraButton', {
    staticClass: "extra_button",
    attrs: {
      "title": "Поиск"
    },
    on: {
      "click": _vm.toggleSearch
    }
  }, [_c('AppSvgIcon', {
    attrs: {
      "icon-name": _vm.$ui.IconSvgName.search,
      "fill": "none"
    }
  })], 1), (_vm.isAuthorized && _vm.hasApiModuleConsultations) ? _c('ExtraButton', {
    staticClass: "extra_button",
    attrs: {
      "title": "Консультации"
    },
    on: {
      "click": _vm.openModal
    }
  }, [_c('AppSvgIcon', {
    staticClass: "consultation_button",
    attrs: {
      "icon-name": _vm.$ui.IconSvgName.consultation
    }
  })], 1) : _vm._e(), (!_vm.accessibilityEnabled) ? _c('ExtraButton', {
    staticClass: "extra_button",
    attrs: {
      "title": "Версия для слабовидящих"
    },
    on: {
      "click": _vm.toggleAccessibility
    }
  }, [_c('AppSvgIcon', {
    staticClass: "btn-light ui_color__gray",
    staticStyle: {
      "margin-right": "0"
    },
    attrs: {
      "icon-name": _vm.$ui.IconSvgName.glasses,
      "size": _vm.$ui.AppSvgIcon.size.large
    }
  })], 1) : _vm._e(), (!_vm.isAuthorized) ? _c('AppButtonNew', {
    staticClass: "enter_button",
    on: {
      "click": _vm.register
    }
  }, [_vm._v("Войти")]) : _c('ExtraButton', {
    staticClass: "extra_button",
    attrs: {
      "title": "Войти"
    },
    on: {
      "click": _vm.register
    }
  }, [_c('AppSvgIcon', {
    attrs: {
      "icon-name": _vm.$ui.IconSvgName.profile
    }
  })], 1), _c('ExtraButton', {
    staticClass: "extra_button",
    attrs: {
      "title": "Меню"
    },
    on: {
      "click": _vm.openMenu
    }
  }, [_c('AppSvgIcon', {
    attrs: {
      "icon-name": _vm.$ui.IconSvgName.strips,
      "fill": "none"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbe96974","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/parts/extra_buttons/ExtraButtons.vue
// module id = bbe00c7304a7ecbdef42
// module chunks = 0